<template>
  <div class="images-box">
    <div v-if="source.src.length > 0" class="image" :key="idx"  v-for="(source, idx) in sources">
      <img @mouseleave="imageSrc = null" @mouseenter="mouseHover(src)"  :src="src" :key="idx" alt="" v-for="(src, idx) in source.src">
    </div>
      <img @mouseleave="imageSrc = null" :class="imageSrc ? 'show-image' : 'd-none'" :src="imageSrc" alt="">
  </div>
</template>

<script>
export default {
  name: 'TasksRightCornerImagesBox',
  props: {
    tasks: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      sources: [],
      imageSrc: null
    };
  },
  mounted(){

  },
  watch: {
    tasks: function(){
      this.sources = [];
      this.tasks.map(task => {
        this.getSrc(task.content);
      })
    }
  },
  methods: {
    mouseHover(src){
      this.imageSrc = src;
    },
    getSrc(data){
      //START get clean images and iframes src
      let splitedString = data.split("<");
      let files = splitedString
          .filter(i => i.startsWith("img"))
          .concat(splitedString.filter(i => i.startsWith("iframe")));
      let sources = [];
      files.map(src => {
        src = src.split('src="');
        let re = /(?:\.([^.]+))?$/;
        src = src[1].split('"')[0];
        let type = re.exec(src)[1];
        let link = re.exec(src)["input"].split(re.exec(src)[0]);
        link = link[0] + "." + type.split("&")[0];
        switch (type.split("&")[0]) {
          case "pdf":
            type = {
              class: "fas fa-file-pdf fa-lg",
              ext: "pdf"
            };
            break;
          case "doc":
            type = {
              class: "fas fa-file fa-lg",
              ext: "doc"
            };
            break;
          case "xlsx":
            type = {
              class: "fas fa-file-excel fa-lg",
              ext: "xlsx"
            };
            break;
          default:
            type = {
              ext: "img"
            };
        }
        sources.push({
          src: src,
          link: link,
          type: type
        });
      });

      let imageSrc = [];
      sources.map( src => {
          if(src.type.ext == 'img'){
            imageSrc.push(src.src);
          }
      } )
      sources = {
        src: imageSrc
      }
      this.sources.push(sources);

    },
  }
}
</script>

<style scoped>
  d-none{
    display: none;
  }
  .show-image{
    position: absolute;
    z-index: 1;
    right: 1rem;
    top: 5rem;
    max-width: 275px;
    max-height: 150px;
    overflow: hidden;
    border-radius: 5px;
    border: 1px solid #4c4c4c;
    transition: .2s;
  }
  .images-box{
    position: absolute;
    height: 28px;
    top: 584px;
    right: 0;
    display: flex;
    padding: 3px;
  }
  .image img{
    width: 15px;
    height: 15px;
    margin-right: 2px;
    cursor: pointer;
  }
  /*.d-none{*/
  /*  display: none;*/
  /*}*/
</style>